<template>
  <span class="breadcrumb-separator" aria-hidden="true"><v-icon>mdi-slash-forward</v-icon></span>
</template>

<script>
export default {
  name: 'BreadcrumbSeparator',
};
</script>

<style lang="scss" scoped>
.breadcrumb-separator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.35);
  font-size: 16px;
  font-weight: 300;
  line-height: 1;
  margin: 0 12px;
  user-select: none;
  pointer-events: none;

  .v-icon {
    color: rgba(255, 255, 255, 0.35);
  }
}

@media (max-width: 600px) {
  .breadcrumb-separator {
    margin: 0 8px;
  }
}
</style>
